/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import Cookies from 'js-cookie';

import { defaultSecurityConfig } from 'modules/auth/constants/configBase';
import { pwcSecurityConfig } from 'modules/auth/constants/configPWC';
import { pldSecurityConfig } from 'modules/auth/constants/configPLD';

export const getTenantConfig = (tenant) => {
  const configs = {
    pwc: pwcSecurityConfig,
    pld: pldSecurityConfig,
    default: defaultSecurityConfig,
  };

  return configs[tenant] || configs.default;
};

const Auth0ProviderWithDynamicConfig = ({ children }) => {
  const location = useLocation();

  const [authConfig, setAuthConfig] = useState(() => {
    const savedTenant = Cookies.get('authTenant');
    return getTenantConfig(savedTenant);
  });

  useEffect(() => {
    const { hash } = location;

    if (hash.includes('/pwc-login')) {
      console.log('PWC Space detected', window.location.origin); // eslint-disable-line

      Cookies.set('authTenant', 'pwc', {
        secure: true,
        sameSite: 'strict',
        // httpOnly: true,
      });

      setAuthConfig(getTenantConfig('pwc'));
    } else if (hash.includes('/pld-login')) {
      console.log('PLD Space detected', window.location.origin); // eslint-disable-line

      Cookies.set('authTenant', 'pld', {
        secure: true,
        sameSite: 'strict',
        // httpOnly: true,
      });

      setAuthConfig(getTenantConfig('pld'));
    } else if (hash.includes('/login')) {
      console.log('STTOK Space detected', window.location.origin); // eslint-disable-line

      Cookies.set('authTenant', 'default', {
        secure: true,
        sameSite: 'strict',
        // httpOnly: true,
      });

      setAuthConfig(getTenantConfig('default'));
    }
  }, [location.hash]); // eslint-disable-line

  const onRedirectCallback = (appState) => {
    const managedErrors = [
      'unauthorized',
      'access_denied',
      'invalid_certificate',
    ];

    if (appState && appState.error) {
      if (managedErrors.includes(appState.error)) {
        const tenant = Cookies.get('authTenant');
        const config = getTenantConfig(tenant);

        window.location.href =
          `https://${config.domain}/authorize?` +
          `response_type=code&` +
          `client_id=${config.clientId}&` +
          `redirect_uri=${encodeURIComponent(
            config.authorizationParams.redirect_uri
          )}&` +
          `connection=${config.authorizationParams.connection}&` +
          `certificate_type=hard&` +
          `prompt=login`;
      }
    }
  };

  return (
    <Auth0Provider
      key={authConfig.domain}
      {...authConfig}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback={false}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithDynamicConfig;
